export default __webpack_public_path__ + "static/media/plusOnLight.560ba6b8.svg";